import Reflux from "reflux";

import Chip from "@reactComponents/lds/chips/Chip";
import FacetSearchStore from "@javascript/stores/facetSearchStore";

const FacetSearchCriteriaQueryTerm = createReactClass({
  mixins: [
    Reflux.connectFilter(
      FacetSearchStore,
      ({searchTerm: {queryTerm, feedPageQueryTerm}}) =>
        ({queryTerm, feedPageQueryTerm})
    )
  ],

  getInitialState() {
    return {
      queryTerm: FacetSearchStore.data.searchTerm.queryTerm,
      feedPageQueryTerm: FacetSearchStore.data.searchTerm.feedPageQueryTerm,
    };
  },

  render(){
    let queryTerm = this.state.queryTerm;
    let feedPageQueryTerm;
    const originalFeedQuery = Zymewire.original_feed_query;

    if(originalFeedQuery){
      if (originalFeedQuery.query && $.trim(originalFeedQuery.query).length > 0){
        queryTerm = _.unescape(queryTerm);
        feedPageQueryTerm = decodeHTMLContent(_.unescape(originalFeedQuery.query));
      }
    }

    if (!queryTerm && !feedPageQueryTerm){
      return (null);
    }

    let editable = true;

    if (queryTerm && feedPageQueryTerm){
      editable = queryTerm.toLowerCase() !== feedPageQueryTerm.toLowerCase();
    }

    return(
      <QueryTermEntry
        editable={editable}
        feedPageQueryTerm={feedPageQueryTerm}
        queryTerm={queryTerm}
      />
    );

  }
});

const QueryTermEntry = ({ editable, feedPageQueryTerm, queryTerm}) => {
  let startingIndex = decodeURI(queryTerm).toLowerCase().indexOf(decodeURI(feedPageQueryTerm).toLowerCase())
  let original_overlap = feedPageQueryTerm ? startingIndex > -1 : false;
  let matching_term;

  if (queryTerm && feedPageQueryTerm && !original_overlap){
    matching_term = `${queryTerm} with ${feedPageQueryTerm}`
  }
  else if (queryTerm){
    matching_term = queryTerm
  }
  else{
    matching_term = feedPageQueryTerm
  }

  let trailingIcon = "cancel";

  let clearQuery = () => {
    $(".search-query").val('');
    FacetSearchStoreActions.setQueryTerm("");
    doEventSearch();
  };

  return (
    <Chip
      className="search_filter_applied_chip"
      label={matching_term}
      leadingIcon="search"
      size="small"
      {...editable && {
        trailingIcon: trailingIcon,
        trailingIconClassName: "search_filter_applied_trailing_icon",
        trailingIconOnClick: clearQuery,
      }}
      variant="secondary"
    />
  )
};

window.FacetSearchCriteriaQueryTerm = FacetSearchCriteriaQueryTerm;
export default FacetSearchCriteriaQueryTerm;
